module.exports = __webpack_public_path__ + "img/car_green.a8dbac96.png";